import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { InputNumber } from 'antd';
import { CheckOutlined, ArrowRightOutlined } from '@ant-design/icons';
import axios from 'axios';
import config from '../../../config';
import { toast } from 'react-toastify';
import { NdoeActionButton } from '../../../components/ndoe';

/*
  Édition du prix d'une ligne de livraison (modernisé 18/07).

  AVANT : après enregistrement, le composant faisait window.location.reload() —
  toute la page se rechargeait et la fenêtre se fermait. Le proprio devait tout
  recommencer.

  MAINTENANT : deux boutons, et on NE recharge JAMAIS la page.
   - « Enregistrer » : sauvegarde, rafraîchit la liste (onSaved) et on RESTE dans
     le menu (la fenêtre se ferme, la page reste).
   - « Enregistrer et voir la commande » : sauvegarde puis ouvre le détail de la
     commande (choix proprio) — pour vérifier l'ensemble d'un coup.
*/
const LivraisonViewPrix = ({ prixTotal, idDetail, userUpdate, idCommande, onSaved }) => {
  const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
  const navigate = useNavigate();
  const [prix, setPrix] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // prixTotal peut arriver en chaîne : on borne à un nombre pour l'InputNumber.
    const n = Number(prixTotal);
    setPrix(Number.isFinite(n) ? n : null);
  }, [prixTotal]);

  // Enregistre le prix. `apresCommande` = true → on va ensuite au détail commande.
  const enregistrer = async (apresCommande) => {
    if (loading) return;
    if (prix == null || !Number.isFinite(Number(prix)) || Number(prix) < 0) {
      toast.warning('Saisissez un prix valide (supérieur ou égal à 0).');
      return;
    }
    setLoading(true);
    try {
      await axios.put(`${DOMAIN}/api/livraison/livraisonPrix/${idDetail}`, { prix: Number(prix), userUpdate });
      toast.success('Prix enregistré.');
      if (onSaved) onSaved();            // rafraîchit la liste + ferme la fenêtre (on reste sur la page)
      if (apresCommande && idCommande) {
        navigate(`/listeDetailView/${idCommande}`);
      }
    } catch (err) {
      toast.error(err.response?.data?.error || err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <label style={{ fontWeight: 600, color: 'var(--ndoe-ink, #071c3d)' }}>Prix de vente</label>
        <InputNumber
          inputMode="decimal"
          min={0}
          value={prix}
          onChange={(v) => setPrix(v)}
          onPressEnter={() => enregistrer(false)}
          addonAfter="$"
          style={{ width: '100%' }}
          autoFocus
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <NdoeActionButton variant="primary" block loading={loading} icon={<CheckOutlined />} onClick={() => enregistrer(false)}>
          Enregistrer
        </NdoeActionButton>
        <NdoeActionButton
          variant="secondary"
          block
          loading={loading}
          icon={<ArrowRightOutlined />}
          disabled={!idCommande}
          onClick={() => enregistrer(true)}
        >
          Enregistrer et voir la commande
        </NdoeActionButton>
      </div>
    </div>
  );
};

export default LivraisonViewPrix;
